import { CheckIcon, XIcon } from 'lucide-react';

import { checkPasswordRules, PASSWORD_RULE_LABELS } from './passwordRules';

const PasswordStrengthIndicator = ({ password }: { password: string }) => {
    const rules = checkPasswordRules(password);

    return (
        <ul className="flex flex-col gap-1 mt-1">
            {(Object.keys(rules) as Array<keyof typeof rules>).map((key) => (
                <li key={key} className={`flex items-center gap-1.5 text-xs ${rules[key] ? 'text-green-600' : 'text-gray-400'}`}>
                    {rules[key]
                        ? <CheckIcon size={12} className="shrink-0" />
                        : <XIcon size={12} className="shrink-0" />
                    }
                    {PASSWORD_RULE_LABELS[key]}
                </li>
            ))}
        </ul>
    );
};

export default PasswordStrengthIndicator;
